import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const viewIntentRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-virtualagent-view-intent',
	exact: true,
	path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/intents/:intentId/:tab(flow|training|settings)?',
};
